export class GORef {
  _object: any;

  constructor(obj: any) {
    this._object = obj;
  }

  get object() {
    // Check if the object is a ProxyObject by checking its type property
    // This avoids circular dependency issues
    if (this._object && this._object.type === 'proxy') {
      return null;
    }
    return this._object;
  }

  get position() {
    return this._object.position;
  }

  get serverObjectIdx() {
    return this._object.serverObjectIdx;
  }
}

